import script from "./SwapView.vue?vue&type=script&setup=true&lang=js"
export * from "./SwapView.vue?vue&type=script&setup=true&lang=js"

import "./SwapView.vue?vue&type=style&index=0&id=677ff16a&lang=css"

const __exports__ = script;

export default __exports__